// helpers
import { isBusinessLineSwiggyMoney } from "@payment-client/helpers/Misc";

// constants
import { SCREEN_NAME } from "@payment-client/analytics/constants";

// util function to handle swiggy money events similar to regular payments
export const getResolvedPaymentsScreenName = (): string => {
    const isSwiggyMoneyFlow = isBusinessLineSwiggyMoney();
    return isSwiggyMoneyFlow ? SCREEN_NAME.SWIGGY_MONEY_PAYMENTS : SCREEN_NAME.PAYMENT;
};

export const stringifyWithUndefinedKeys = (item: unknown): string =>
    JSON.stringify(item, (_key, value) => (value === undefined ? null : value));
